import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Message, MessageTop, Header, HeaderContent } from './style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["className", "header", "partner"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var PartnerMessage = function PartnerMessage(props) {
  var className = props.className,
    header = props.header,
    partner = props.partner,
    rest = _objectWithoutProperties(props, _excluded);
  if (typeof header !== 'string' || !header || !partner) {
    return false;
  }
  return /*#__PURE__*/jsx(Message, _objectSpread(_objectSpread({
    className: className
  }, rest), {}, {
    partner: partner,
    children: /*#__PURE__*/jsxs(MessageTop, {
      children: [/*#__PURE__*/jsx("img", {
        alt: partner,
        src: "https://img.nltg.com/image/upload/h_22,f_webp/web/partners/".concat(partner, ".png")
      }), /*#__PURE__*/jsx(Header, {
        partner: partner,
        children: /*#__PURE__*/jsx(HeaderContent, {
          children: header
        })
      })]
    })
  }));
};
PartnerMessage.defaultProps = {
  className: null
};
var PartnerMessage$1 = PartnerMessage;

export { PartnerMessage$1 as default };
//# sourceMappingURL=PartnerMessage.js.map
